import type { TokenPayloadDto } from '@ts/core/src/modules/auth/dto/TokenPayloadDto'

type AuthTokenState = {
  token?: string | TokenPayloadDto | null
  impersonationToken?: string | null
}

export const getAuthAccessToken = ({
  token,
  impersonationToken,
}: AuthTokenState): string | undefined => {
  if (impersonationToken) {
    return impersonationToken
  }

  if (!token) {
    return undefined
  }

  if (typeof token === 'string') {
    return token
  }

  return token.accessToken
}
